import { KeyLabel } from '../domain/key-label.model';

export enum EpgStatus {
  OK = 'ok',
  SAMSUNG_RESOLVE_OK = 'samsung_resolve_ok',
  SAMSUNG_RESOLVE_ERROR = 'samsung_resolve_error',
  REQUEST_NOT_SENT = 'request_not_sent',
  REQUEST_THROTTLED = 'request_throttled',
  REQUEST_ERROR = 'request_error',
  RESPONSE_NO_CONTENT = 'response_no_content',
  RESPONSE_ERROR = 'response_error'
}

export const EpgStatusLabels = {
  [EpgStatus.OK]: 'OK',
  [EpgStatus.SAMSUNG_RESOLVE_OK]: 'Samsung Resolve OK',
  [EpgStatus.SAMSUNG_RESOLVE_ERROR]: 'Samsung Resolve Error',
  [EpgStatus.REQUEST_NOT_SENT]: 'Request Not Sent',
  [EpgStatus.REQUEST_THROTTLED]: 'Request Throttled',
  [EpgStatus.REQUEST_ERROR]: 'Request Error',
  [EpgStatus.RESPONSE_NO_CONTENT]: 'Response No Content',
  [EpgStatus.RESPONSE_ERROR]: 'Response Error'
};

export const EpgStatusKL = () =>
  Object.keys(EpgStatus).map(key =>
    new KeyLabel<EpgStatus>(
      EpgStatus[key],
      EpgStatusLabels[EpgStatus[key]]
    )
  );

export const EpgStatusList = Object.values(EpgStatus);
